/* unplugin-vue-components disabled */import { render } from "./Jumbotron.vue?vue&type=template&id=82c53c78&scoped=true"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"

import "./Jumbotron.vue?vue&type=style&index=0&id=82c53c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c53c78"]])

export default __exports__